export const missions = [
  {
    title: "Trasformazione digitale",
    description:
      "Grazie al Team di ricerca e sviluppo, SET è sempre all’avanguardia, pronto per garantire una digitalizzazione unica e professionale.",
    icon: "fas fa-laptop-code",
  },
  {
    title: "Sviluppo del capitale umano",
    description:
      "Insieme a SET costruirai il team perfetto adatto alla tua business.",
    icon: "fas fa-user-friends ",
  },
  {
    title: "Incubazione e accelerazione di impresa",
    description:
      "Con il programma di incubazione e accelerazione SET offre una rapida crescita e stabilizzazione dell’ azienda nel mercato attivo.",
    icon: "fas fa-globe",
  },
  {
    title: "Intelligence per l'internazionalizzazione",
    description:
      "Apri le frontiere del tuo business con l’aiuto di SET, espansione e diversità sono i punti chiave per un’ azienda prosperosa.",
    icon: "fas fa-server",
  },
  {
    title: "Piattaforme per comunità collaborative",
    description:
      "But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born.",
    icon: "fas fa-users",
  },
  {
    title: "Partnership pubblico - privato",
    description:
      "SET aiuta enti pubblici e aziende private a trovare le loro necessità in modo cooperativo e benefico per le entrambe parti.",
    icon: "fas fa-handshake",
  },
  {
    title: "Innovazione e capacity building nella PA",
    description:
      "SET introduce i suoi clienti ad aggregarsi a progetti pubblico-privato finanziati da enti pubblici.",
    icon: "fas fa-lightbulb",
  },
];
